import Vue from 'vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

// 创建加载指令
const loadingDirective = {
  bind(el, binding, vnode) {
    // 创建加载组件实例
    const LoadingConstructor = Vue.extend(LoadingSpinner)
    const loadingInstance = new LoadingConstructor({
      propsData: {
        visible: binding.value,
        text: binding.arg || '加载中...',
        subText: binding.modifiers.subText ? binding.modifiers.subText : ''
      }
    })
    
    // 挂载到 body
    loadingInstance.$mount()
    document.body.appendChild(loadingInstance.$el)
    
    // 存储实例引用
    el._loadingInstance = loadingInstance
    
    // 监听值变化
    el._loadingWatcher = vnode.context.$watch(
      () => binding.value,
      (newVal) => {
        loadingInstance.visible = newVal
      }
    )
  },
  
  update(el, binding) {
    if (el._loadingInstance) {
      // 更新文本内容
      if (binding.arg) {
        el._loadingInstance.text = binding.arg
      }
      
      // 更新显示状态
      el._loadingInstance.visible = binding.value
    }
  },
  
  unbind(el) {
    // 清理资源
    if (el._loadingInstance) {
      document.body.removeChild(el._loadingInstance.$el)
      el._loadingInstance.$destroy()
      el._loadingInstance = null
    }
    
    if (el._loadingWatcher) {
      el._loadingWatcher()
      el._loadingWatcher = null
    }
  }
}

// 注册指令
Vue.directive('loading', loadingDirective)

// 导出指令，方便在其他地方使用
export default loadingDirective 